module.exports = __webpack_public_path__ + "img/xiaozi_shengtai.3526d955.svg";